<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col cols="12">
                <v-text-field
                  v-model="form.userws"
                  :rules="[rules.required, rules.formatInt, rules.minLengthInt]"
                  label="Usuario de Integración"
                  maxlength="30"
                  required
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="form.email_address1"
                  :rules="[rules.required, rules.emailRules]"
                  maxlength="100"
                  label="Correo Electrónico"
                  required
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    components: {
      FormToolbar,
    },
    props: {
      enterpriseId: { default: '' },
      id: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        userws: '',
        email_address1: '',
        busy: false,
      }),

      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        minLengthInt: (v) => v.length > 7 || 'El campo debe tener al menos 8 caracteres.',
        emailRules: (v) => /.+@.+\..+/.test(v) || 'Debe introducir un correo electrónico válido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Usuario de Integración',
      apiURL: '/api/enterprises',
      apiURLUser: 'integrations/store',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      const URL = `${this.apiURL}/${this.enterpriseId}/${this.apiURLUser}`;
      this.URL = URL;
      if (this.id) {
        window.axios.get(`/api/enterprises/${this.enterpriseId}/integrations/${this.id}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.URL = `/api/enterprises/${this.enterpriseId}/integrations/${this.id}/update`;
          this.method = 'PUT';
          this.title = 'Editar Usuario de Integración';
          this.message = `Se ha editado el usuario de Integración ${result.data.name} exitosamente.`;
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then((result) => {
          this.$router.push({
        name: 'integrations',
        params: {
        enterprise_id: this.enterpriseId, id: this.id, action: 'created', message: result.data.message,
        },
        });
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
